<template>
  <div id="profile">
    <nav-bar-top />
    <div class="container has-nav-top-margin">
      <profile-candidate
        :account="account"
        :profile="activeCandidateProfile"
      />
      <div id="bottom-bar">
        <div class="message-candidate has-text-right">
          <button
            class="button is-floating is-rounded is-success has-text-weight-bold"
            @click="joinChatRoom()"
          >
            <i class="fas fa-comment" />
            &nbsp;&nbsp;
            <small>Message</small>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileCandidate from '@/components/CandidateProfile/ProfileCandidate';
import NavBarTop from '@/components/Navigation/NavBarTop';

export default {
  name: 'Profile',
  components: {
    ProfileCandidate,
    NavBarTop
  },
  computed: {
    account () {
      return this.$store.state.user.account;
    },
    activeCandidateProfile () {
      return this.$store.state.activeCandidateProfile;
    },
    roomData () {
      return {
        author: {
          id: this.account._id,
          user_name: this.account.username,
          type: this.account.user_type
        },
        recipient: {
          id: this.activeCandidateProfile._id,
          user_name: this.activeCandidateProfile.username,
          type: 'candidate'
        }
      };
    },
    messageData () {
      return {
        author: {
          id: this.account._id,
          user_name: `${this.account.first_name} from ${this.account.company}`,
          type: this.account.user_type
        },
        recipient: {
          id: this.activeCandidateProfile._id,
          user_name: this.activeCandidateProfile.username,
          type: 'candidate'
        },
        message: `${this.account.first_name} ${
          this.account.last_name
        } wants to chat about an opportunity!`
      };
    }
  },
  methods: {
    joinChatRoom () {
      this.$socket.emit('join_room', this.roomData);
      // initial message has to be sent to open the chat room.
      this.sendMessage();
      this.$router.push('/chat');
    },
    sendMessage () {
      this.$socket.emit('message_sent', this.messageData);
    }
  }
};
</script>

<style lang="scss" scoped>
#bottom-bar {
  position: fixed;
  left: 0;
  width: 100vw;
  padding: 2rem 2rem;
  background-color: transparent;
}

.button.is-floating {
  box-shadow: 2px 3px 26px 2px rgba(54, 54, 54, 0.2);
}

@media screen and (min-width: 0px) {
  #bottom-bar {
    bottom: 0;
  }
  .has-nav-top-margin {
    padding-top: 3.5rem;
  }
}
</style>
